function X3(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="m0 360 120-120 120 120-120 120zM0 120 120 0l120 120-120 120zM240 120 360 0l120 120-120 120zM240 360l120-120 120 120-120 120z"></path></svg>
    )
}

export default X3